<template>
  <div>
    <div class="group">
      {{ group.name }}
      <span style="margin-left: 5px">
        {{ group.activeLocationCount }} / {{ group.locationCount }} 地点
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Group',
  props: {
    group: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style scoped>
.group {
  padding: 5px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
